import * as types from './mutation_types'

export default {
  [types.SET_DATA] (state, value) {
    state.data = value
  },
  [types.SET_STYLE] (state, value) {
    state.style = value
  },
  [types.SET_METATDATA] (state, value) {
    state.metadata = value
  },
  [types.SET_CURRENT_BORDER_WIDTH] (state, value) {
    state.currentBorderWidth = value
  },
  [types.SET_CURRENT_BORDER_COLOR] (state, value) {
    state.currentBorderColor = value
  },
  [types.SET_TYPE_DONNEES] (state, value) {
    state.typeDonnees = value
  },
  [types.SET_PROJECTS_LIST] (state, value) {
    state.projectsList = value
  },
  [types.SET_TABLEAUX_LIST] (state, value) {
    state.tableauxList = value
  },
  [types.DISABLED_ADD_TABLEAU] (state, value) {
    state.disabledAddTableau = value
  },
  [types.SET_ESPACE_FROM_TABLEAU] (state, value) {
    state.espacesList = value
  },
  [types.SET_TABLEAU_BY_ID] (state, value) {
    state.tableauDataById = value
  },
  [types.SET_CURRENT_PROJECT] (state, value) {
    state.currentProject = value
  },
  [types.SET_LIST_ONGLET] (state, value) {
    state.listOnglet = value
  },
  [types.SET_PERMISSION] (state, value) {
    state.getPermissions = value
  },
  [types.SET_FICHES] (state, value) {
    state.setFiches = value
  },
  [types.SET_CURRENT_ONGLET] (state, value) {
    state.currentOnglet = value
  },
  [types.SHOW_TYPE] (state, value) {
    state.showType = value
  },
  [types.IS_PROJECT_TEMPLATE] (state, value) {
    state.isProjectTemplate = value
  },
  [types.IS_COPIED] (state, value) {
    state.isCopied = value
  },
  [types.IS_CLONING_FORMAT] (state, value) {
    state.isCloningFormat = value
  },
  [types.IS_SELECTING_COLOR] (state, value) {
    state.isSelectingColor = value
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/tableau/mutations.js